import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { Reports } from './Reports';

const ReportsBridge = react2angular(Reports, ['backFromState']);

export default ReportsBridge;
